import produce from 'immer';
import {
  SHOW_SPINNER,
  HIDE_SPINNER,
  TOAST_WARNING,
  TOAST_SUCCESS,
  TOAST_ERROR,
  SET_USER_INFO,
  SET_UPDATE_LOGGED_INFO,
} from './constants';

export const initialState = {
  spinner: { visible: false, message: '', timeStamp: 0 },
  toast: { type: 0, message: '' },
  userInfo: null,
  loggedInEmployee: { name: '', approvalLimit: 0 },
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SHOW_SPINNER:
        draft.spinner = {
          visible: true,
          message: payload,
        };
        break;
      case HIDE_SPINNER:
        draft.spinner = {
          visible: false,
          message: null,
        };
        break;
      case TOAST_SUCCESS:
        draft.toast = { type: 1, message: payload };
        break;
      case TOAST_WARNING:
        draft.toast = { type: 2, message: payload };
        break;
      case TOAST_ERROR:
        draft.toast = { type: 3, message: payload };
        break;
      case SET_USER_INFO:
        draft.userInfo = payload;
        break;
      case SET_UPDATE_LOGGED_INFO:
        // eslint-disable-next-line no-lone-blocks
        {
          if (draft?.userInfo?.userID?.toUpperCase() === payload?.employeeId?.toUpperCase()) {
            draft.loggedInEmployee = {
              name: payload.name ?? draft.loggedInEmployee.name,
              approvalLimit: payload.approvalLimit ?? draft.loggedInEmployee.approvalLimit,
            };
          }
        }
        break;
      default:
        break;
    }
  });

export default reducer;
